import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class HeaderService {
  private headerHeightSource = signal<number>(0);
  readonly headerHeightSource$ = this.headerHeightSource.asReadonly();

  private showHeaderTags = signal<boolean>(true);
  readonly showHeaderTags$ = this.showHeaderTags.asReadonly();

  setHeaderHeight(height: number) {
    this.headerHeightSource.set(height);
  }

  headerTagsVisibility(visibility: boolean) {
    this.showHeaderTags.set(visibility);
  }
}
